import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'marketFormat'
})
export class MarketFormatPipe implements PipeTransform {

    private marketMappings: any = {
        // PP Stations
        'AKRON-OH': 'Akron, Ohio',
        'ALLENTOWN-PA': 'Allentown, Pennsylvania',
        'ALBANY-GA': 'Albany, Georgia',
        'ALBANY-NY': 'Albany, New York',
        'ALBUQUERQUE-NM': 'Albuquerque, New Mexico',
        'ANCHORAGE-AK': 'Anchorage, Alaska',
        'ASHEVILLE-NC': 'Asheville, North Carolina',
        'ATLANTA-GA': 'Atlanta, Georgia',
        'AUBURN-AL': 'Auburn, Alabama',
        'AUGUSTA-GA': 'Augusta, Georgia',
        'AURORA-IL': 'Aurora, Illinois',
        'AUSTIN-TX': 'Austin, Texas',
        'BAKERSFIELD-CA': 'Bakersfield, California',
        'BALTIMORE-MD': 'Baltimore, Maryland',
        'BATONROUGE-LA': 'Baton Rouge, Louisiana',
        'BEAUMONT-TX': 'Beaumont, Texas',
        'BILOXI-MS': 'Biloxi, Mississippi',
        'BINGHAMTON-NY': 'Binghamton, New York',
        'BIRMINGHAM-AL': 'Birmingham, Alabama',
        'BISMARCK-ND': 'Bismarck, North Dakota',
        'BOSTON-MA': 'Boston, Massachusetts ',
        'BRUNSWICK-GA': 'Brunswick, Georgia',
        'BRYAN-TX': 'Bryan, Texas',
        'CANTON-OH': 'Canton, Ohio',
        'CAPECOD-MA': 'Cape Cod, Massachusetts',
        'CEDARRAPIDS-IA': 'Cedar Rapids, Iowa',
        'CHARLESTON-SC': 'Charleston, South Carolina',
        'CHARLOTTE-NC': 'Charlotte, North Carolina',
        'CHATTANOOGA-TN': 'Chattanooga, Tennessee',
        'CHEYENNE-WY': 'Cheyenne, Wyoming',
        'CHICAGO-IL': 'Chicago, Illinois',
        'CHILLICOTHE-OH': 'Chillicothe, Ohio',
        'CINCINNATI-OH': 'Cincinnati, Ohio',
        'CLEVELAND-OH': 'Cleveland, Ohio',
        'COLORADOSPRINGS-CO': 'Colorado Springs, Colorado',
        'COLUMBIA-SC': 'Columbia, South Carolina',
        'COLUMBUS-GA': 'Columbus, Georgia',
        'COLUMBUS-OH': 'Columbus, Ohio',
        'CORPUSCHRISTI-TX': 'Corpus Christi, Texas',
        'DALLAS-TX': 'Dallas, Texas',
        'DAVENPORT-IA': 'Davenport, Iowa',
        'DAYTON-OH': 'Dayton, Ohio',
        'DEFIANCE-OH': 'Defiance, Ohio',
        'DENVER-CO': 'Denver, Colorado',
        'DESMOINES-IA': 'Des Moines, Iowa',
        'DETROIT-MI': 'Detroit, Michigan',
        'DICKINSON-ND': 'Dickinson, North Dakota',
        'DIGITAL-NAT': 'Digital, Natives',
        'EAUCLAIRE-WI': 'Eau Claire, Wisconsin',
        'ELPASO-TX': 'El Paso, Texas',
        'FAIRBANKS-AK': 'Fairbanks, Alaska',
        'FARMINGTON-NM': 'Farmington, New Mexico',
        'FAYETTEVILLE-AR': 'Fayetteville, Arkansas',
        'FLORENCE-SC': 'Florence, South Carolina',
        'FLORIDAKEYS-FL': 'Florida Keys, Florida',
        'FORTCOLLINS-CO': 'Fort Collins, Colorado',
        'FRESNO-CA': 'Fresno, California',
        'FTMYERS-FL': 'Fort Myers, Florida',
        'FTSMITH-AR': 'Fort Smith, Arkansas',
        'GADSDEN-AL': 'Gadsden, Alabama',
        'GALLUP-NM': 'Gallup, New Mexico',
        'GRANDFORKS-ND': 'Grand Forks, North Dakota',
        'GRANDRAPIDS-MI': 'Grand Rapids, Michigan',
        'GREENSBORO-NC': 'Greensboro, North Carolina',
        'GREENVILLE-SC': 'Greenville, South Carolina',
        'HARRISBURG-PA': 'Harrisburg, Pennsylvania',
        'HARRISONBURG-VA': 'Harrisonburg, Virginia',
        'HARTFORD-CT': 'Hartford, Connecticut',
        'HONOLULU-HI': 'Honolulu, Hawaii',
        'HOUSTON-TX': 'Houston, Texas',
        'HUNTINGTON-WV': 'Huntington, West Virginia',
        'HUNTSVILLE-AL': 'Huntsville, Alabama',
        'INDIANAPOLIS-IN': 'Indianapolis, Indiana',
        'JACKSON-MS': 'Jackson, Mississippi',
        'JACKSONVILLE-FL': 'Jacksonville, Florida',
        'JOLIET-IL': 'Joliet, Illinois',
        'LANCASTER-PA': 'Lancaster, Pennsylvania',
        'LASVEGAS-NV': 'Las Vegas, Nevada',
        'LAUREL-MS': 'Laurel, Mississippi',
        'LEXINGTON-KY': 'Lexington, Kentucky',
        'LIMA-OH': 'Lima, Ohio',
        'LITTLEROCK-AR': 'Little Rock, Arkansas',
        'LOSANGELES-CA': 'Los Angeles, California',
        'LOUISVILLE-KY': 'Louisville, Kentucky',
        'MACON-GA': 'Macon, Georgia',
        'MADISON-WI': 'Madison, Wisconsin',
        'MANCHESTER-NH': 'Manchester, New Hampshire',
        'MANSFIELD-OH': 'Mansfield, Ohio',
        'MARION-OH': 'Marion, Ohio',
        'MCALLEN-TX': 'McAllen, Texas',
        'MELBOURNE-FL': 'Melbourne, Florida',
        'MEMPHIS-TN': 'Memphis, Tennessee',
        'MIAMI-FL': 'Miami, Florida',
        'MILWAUKEE-WI': 'Milwaukee, Wisconsin',
        'MINNEAPOLIS-MN': 'Minneapolis, Minnesota',
        'MINOT-ND': 'Minot, North Dakota',
        'MOBILE-AL': 'Mobile, Alabama',
        'MODESTO-CA': 'Modesto, California',
        'MONTEREY-CA': 'Monterey, California',
        'MONTGOMERY-AL': 'Montgomery, Alabama',
        'MUSKEGON-MI': 'Muskegon, Michigan',
        'MYRTLEBEACH-SC': 'Myrtle Beach, South Carolina',
        'NASHVILLE-TN': 'Nashville, Tennessee',
        'NEWHAVEN-CT': 'New Haven, Connecticut',
        'NEWORLEANS-LA': 'New Orleans, Louisiana',
        'NEWYORK-NY': 'New York, New York',
        'NORFOLK-VA': 'Norfolk, Virginia',
        'OGALLALA-NE': 'Ogallala, Nebraska',
        'OKLAHOMACITY-OK': 'Oklahoma City, Oklahoma',
        'OMAHA-NE': 'Omaha, Nebraska',
        'ORLANDO-FL': 'Orlando, Florida',
        'PANAMACITY-FL': 'Panama City, Florida',
        'PARKERSBURG-WV': 'Parkersburg, West Virginia',
        'PHILADELPHIA-PA': 'Philadelphia, Pennsylvania',
        'PHOENIX-AZ': 'Phoenix, Arizona',
        'PITTSBURGH-PA': 'Pittsburgh, Pennsylvania',
        'PORTLAND-OR': 'Portland, Oregon',
        'PORTSMOUTH-NH': 'Portsmouth, New Hampshire',
        'POUGHKEEPSIE-NY': 'Poughkeepsie, New York',
        'PROVIDENCE-RI': 'Providence, Rhode Island',
        'PUEBLO-CO': 'Pueblo, Colorado',
        'RALEIGH-NC': 'Raleigh, North Carolina',
        'READING-PA': 'Reading, Pennsylvania',
        'RICHMOND-VA': 'Richmond, Virginia',
        'RIVERSIDE-CA': 'Riverside, California',
        'ROANOKE-VA': 'Roanoke, Virginia',
        'ROCHESTER-MN': 'Rochester, Minnesota',
        'ROCHESTER-NY': 'Rochester, New York',
        'SACRAMENTO-CA': 'Sacramento, California',
        'SALISBURY-MD': 'Salisbury, Maryland',
        'SALTLAKECITY-UT': 'Salt Lake City, Utah',
        'SANANTONIO-TX': 'San Antonio, Texas',
        'SANDIEGO-CA': 'San Diego, California',
        'SANFRANCISCO-CA': 'San Francisco, California',
        'SARASOTA-FL': 'Sarasota, Florida',
        'SAVANNAH-GA': 'Savannah, Georgia',
        'SEATTLE-WA': 'Seattle, Washington',
        'SIOUXCITY-IA': 'Sioux City, Iowa',
        'SOMERSET-KY': 'Somerset, Kentucky',
        'SPOKANE-WA': 'Spokane, Washington',
        'SPRINGFIELD-MA': 'Springfield, Massachusetts',
        'SPRINGFIELD-MO': 'Springfield, Missouri',
        'STLOUIS-MO': 'Saint Louis, Missouri',
        'STOCKTON-CA': 'Stockton, California',
        'SUSSEX-NJ': 'Sussex, New Jersey',
        'SYRACUSE-NY': 'Syracuse, New York',
        'TALLAHASSEE-FL': 'Tallahassee, Florida',
        'TAMPA-FL': 'Tampa, Florida',
        'TOLEDO-OH': 'Toledo, Ohio',
        'TUCSON-AZ': 'Tucson, Arizona',
        'TULSA-OK': 'Tulsa, Oklahoma',
        'TUPELO-MS': 'Tupelo, Mississippi',
        'TUSCALOOSA-AL': 'Tuscaloosa, Alabama',
        'VALLEY-AL': 'Valley, Alabama',
        'WACO-TX': 'Waco, Texas',
        'WASHINGTON-DC': 'Washington, District of Columbia',
        'WAUKEGAN-IL': 'Waukegan, Illinois',
        'WESTPALMBEACH-FL': 'West Palm Beach, Florida',
        'WHEELING-WV': 'Wheeling, West Virginia',
        'WICHITA-KS': 'Wichita, Kansas',
        'WILLIAMSPORT-PA': 'Williamsport, Pennsylvania',
        'WILMINGTON-DE': 'Wilmington, Delaware',
        'WINCHESTER-VA': 'Winchester, Virginia',
        'WORCESTER-MA': 'Worcester, Massachusetts',
        'YOUNGSTOWN-OH': 'Youngstown, Ohio',

        // MM Stations
        'Akron': 'Akron, Ohio',
        'Albuquerque': 'Albuquerque, New Mexico',
        'Allentown': 'Allentown, Pennsylvania',
        'Atlanta': 'Atlanta, Georgia',
        'Austin': 'Austin, Texas',
        'Bakersfield': 'Bakersfield, California',
        'Baltimore': 'Baltimore, Maryland',
        'Baton Rouge': 'Baton Rouge, Los Angeles',
        'Birmingham': 'Birmingham, Alabama',
        'Boston': 'Boston, Massachusetts',
        'Buffalo': 'Buffalo, New York',
        'Charleston, SC': 'Charleston, South Carolina',
        'Charlotte': 'Charlotte, North Carolina',
        'Chicago': 'Chicago, Illinois',
        'Cincinnati': 'Cincinnati, Ohio',
        'Cleveland': 'Cleveland, Ohio',
        'Dallas-Ft.Worth': 'Dallas, Texas',
        'Dayton': 'Dayton, Ohio',
        'Denver': 'Denver, Colorado',
        'Des Moines': 'Des Moines, Iowa',
        'Detroit': 'Detroit, Michigan ',
        'Fresno': 'Fresno, California',
        'Ft. Myers-Naples': 'Fort Myers, Florida ',
        'Grand Rapids': 'Grand Rapids, Michigan',
        'Greensboro': 'Greensboro, North Carolina',
        'Greenville-Spartanburg': 'Greenville, South Carolina',
        'Harrisburg': 'Harrisburg, Pennsylvania',
        'Hartford': 'Hartford, Connecticut',
        'Honolulu': 'Honolulu, Hawaii',
        'Houston': 'Houston, Texas',
        'Indianapolis': 'Indianapolis, Indiana',
        'Jacksonville': 'Jacksonville, Florida',
        'Kansas City': 'Kansas City, Missouri',
        'Knoxville': 'Knoxville, Tennessee',
        'Las Vegas': 'Las Vegas, Nevada',
        'Little Rock': 'Little Rock, Arizona',
        'Los Angeles': 'Los Angeles, California',
        'Louisville': 'Louisville, Kentucky',
        'Madison, WI': 'Madison, Wisconsin',
        'McAllen-Brownsville': 'McAllen, Texas',
        'Memphis': 'Memphis, Tennessee',
        'Miami': 'Miami, Florida',
        'Middlesex': 'Middlesex, New Jersey',
        'Milwaukee': 'Milwaukee, Wisconsin',
        'Minneapolis': 'Minneapolis, Minnesota',
        'Monmouth-Ocean': 'Monmouth, New Jersey',
        'Monterey-Salinas': 'Monterey, California',
        'Nashville': 'Nashville, Tennessee',
        'Nassau-Suffolk': 'Nassau-Suffolk, New York',
        'New Orleans': 'New Orleans, Los Angeles',
        'New York': 'New York, New York',
        'Norfolk': 'Norfolk, Virginia',
        'Oklahoma City': 'Oklahoma City, Oklahoma',
        'Omaha': 'Omaha, Nebraska',
        'Orlando': 'Orlando, Florida',
        'Philadelphia': 'Philadelphia, Pennsylvania',
        'Phoenix': 'Phoenix, Arizona',
        'Pittsburgh': 'Pittsburgh, Pennsylvania',
        'Providence': 'Providence, Rhode Island',
        'Raleigh-Durham': 'Raleigh, North Carolina',
        'Richmond': 'Richmond, Virginia',
        'Riverside-San Bernardino': 'Riverside, California',
        'Rochester, NY': 'Rochester, New York',
        'Sacramento': 'Sacramento, California',
        'Salt Lake City': 'Salt Lake City, Utah',
        'San Antonio': 'San Antonio, Texas',
        'San Diego': 'San Diego, California',
        'San Francisco': 'San Francisco, California',
        'San Jose': 'San Jose, California',
        'Seattle': 'Seattle, Washington',
        'Spokane': 'Spokane, Washington',
        'St. Louis': 'Saint Louis, Missouri',
        'Tampa-St. Petersburg': 'Tampa, Florida',
        'Toledo': 'Toledo, Ohio',
        'Tucson': 'Tucson, Arizona',
        'Tulsa': 'Tulsa, Oklahoma',
        'Washington, DC': 'Washington, District of Columbia',
        'West Palm Beach': 'West Palm Beach, Florida',
        'Wilkes Barre-Scranton': 'Wilkes Barre-Scranton, Pennsylvania',
    };

    transform(value: any): string {
        const result: string = this.marketMappings[value] ? this.marketMappings[value] : value;
        return result;
    }

}
